module.exports = __webpack_public_path__ + "static/about-team-51ccdf532e7129c9123a2ad0660749f3.jpg";